<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 my-4 fw-bold title">{{ appNameDesktop }}</div>
    </div>
    <div class="row">
      <div class="col-12 mt-3">
        <ul class="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">
          <li class="list-inline-item"><a [routerLink]="['/cms', 'accessibilita']">Accessibilità</a></li>
          <li class="list-inline-item">|</li>
          <li class="list-inline-item"><a [routerLink]="['/cms', 'contatti']">Contatti</a></li>
          <li class="list-inline-item">|</li>
          <!--<li class="list-inline-item"><a href="">Credits</a></li>-->
          <li class="list-inline-item"><a style="cursor:pointer;" (click)="downloadManuale()">Manuale</a></li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-12 my-3 copyright">
        <span class="d-inline-block">&copy; Copyright Regione Lombardia tutti i diritti riservati</span>
        <span class="d-inline-block"> - C.F. 80050050154</span>
        <span class="d-inline-block"> - Piazza Città di Lombardia 1</span>
        <span class="d-inline-block"> - 20124 Milano</span>
      </div>
    </div>
  </div>
</footer>
